import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import { getClients } from "../helpers/Clients";
import { Link } from "react-router-dom";


export default function Clients() {
    const { appState } = useAppState();
    const [clients, setClients] = useState<Array<any>>([])

    useEffect(() => {
        getClients().then((result) => {
            setClients(result)
        })
    }, [])

    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Clients</h1>
                <Link to="/clients/create" className="px-4 py-2 bg-blue-500 text-white rounded">Create client</Link>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <table className="w-full">
                    <thead className="text-left">
                        <tr className="border-b-1">
                            <th className="p-2">Id</th>
                            <th className="p-2">Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clients.map((client: any) => {
                            return (
                                <tr className="border-b-1 border-gray-300">
                                    <td className="p-2">{client.id}</td>
                                    <td className="p-2">{client.name}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </>
    );
}
